import { FaBell } from "react-icons/fa";
import { IoSettings } from "react-icons/io5";
import { MdMessage } from "react-icons/md";


export const links = [
  {
    name: "Case",
    submenu:[
      {
          name:'Add Case',
          path:'/dashboard/Importcase'
      },
      {
          name:'Show Case',
          path:'/dashboard/Updateshowcases'
      }
    ]
  },
  // {
  //   name: "Client",
  //   submenu:[
  //     {
  //         name:'Add Client',
  //         path:'/dashboard/clientform'
  //     },
  //     {
  //         name:'Show Client',
  //         path:'/dashboard/clientformdata'
  //     }
  //   ]
  // },
  {
    name: "People",
    submenu:[
      {
          name:'Add People',
          path:'/dashboard/peopleform'
      },
      {
          name:'Show People',
          path:'/dashboard/clientformdata'
      }
    ]
  },
  {
    name: "Calendar",
    path: "/dashboard/calendarform"
  },
  {
    name: "Document",
    submenu: [ 
      {
        name: "Genrate Doc's",
        path: "/genrationdocs"
      },
      {
        name: "Show Documents",
        path: "/services/graphic-design"
      },
      {
        name: "Review Doc",
        path: "/dashboard/reviewdocform"
      },
      {
        name: "convert Doc",
        path: "/dashboard/convertdocument"
      }
    ]
  },
  {
    name: "Invoices",
    submenu:[
      {
          name:'Add Invoices',
          path:'/dashboard/invoicesform'
      },
      {
          name:'Show Invoices',
          path:'/dashboard/invoicesformdata'
      }
    ]
  },
  {
    name: "Bills",
    submenu:[
      {
          name:'Add Bills',
          path:'/dashboard/billform'
      },
      {
          name:'Show Bills',
          path:'/dashboard/billformdata'
      }
    ]
  },
  {
    name: "Teams",
    submenu:[
      {
          name:'Add Teams',
          path:'/dashboard/teammemberform'
      },
      {
          name:'Show Team',
          path:'/dashboard/teammemberdata'
      }
    ]
  },
  {
    name: "Tasks",
    submenu:[
      {
          name:'Add Tasks',
          path:'/dashboard/alertsform'
      },
      {
          name:'Show Tasks',
          path:'/dashboard/alertsformdata'
      }
    ]
  },

  {
    name: "Proxy Council",
    submenu:[
      {
          name:'Add Proxy',
          path:'/dashboard/proxy'
      },
      {
          name:'Show Proxy',
          path:'/dashboard/proxydata'
      }
    ]
  },

  {
    bell: <FaBell />,
    path: "/dashboard/notifications"
},
  {
    msg: <MdMessage />,
    path: "/Chatpage"
},

];
